import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { VppApplicationsStoreActions, VppApplicationsStoreSelectors } from '../vpp-applications';
import { VppApplication } from '../vpp-applications/vpp-applications.state';

@Injectable()
export class VppApplicationsResolver {
  constructor(private readonly vppApplicationsStore: Store<VppApplication>) {}

  resolve(): Observable<boolean> {
    return this.vppApplicationsStore.select(VppApplicationsStoreSelectors.selectAllVppApplications).pipe(
      tap((vppApplications) => {
        // Only load the vpp applications if they aren't already loaded
        if (vppApplications.length < 1) {
          this.vppApplicationsStore.dispatch(
            VppApplicationsStoreActions.VppApplicationsResolverActions.vppApplicationsRequested()
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
